export default __webpack_public_path__ + "static/media/course-img.a780ff3d.png";